import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0087 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="ノー残業デーの導入について。継続するためのポイントとは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.12.24</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        持続的な事業運営を推し進める施策の一つとして、「ノー残業デー」の導入が挙げられます。ノー残業デーとは、会社全体、もしくは部署ごとに
        <span>特定の曜日は残業をせずに、定時で退勤する日を設定すること</span>
        です。当然、無計画に仕事を進めていくような状態では、定時退社できるとは考え難く、企業内の悪い習慣として根付いてしまうことがあります。今回は、ノー残業デーについて解説をします。
      </p>
      <img src="/images/column/details/c0087.jpg" alt="キンクラコラム画像87" />
      <div id="toc1">
        <h1>ノー残業デーが必要とされる背景</h1>
      </div>
      <p>
        多くの労働者が健康かつ安心して働くことができる会社でなければ
        <span>
          離職者も続出し、人手不足ゆえに特定の労働者に対する業務負荷が強くなる
        </span>
        ことが容易に想像できます。特定の労働者に対する業務負荷が強くなるということは、
        <span>時間外労働時間数が増えてしまい、人件費の膨張</span>
        （中小企業も2023年4月1日から月に60時間超の割増率は25%から50%に改正）だけでなく、各労働者の健康被害にも繋がる大きな問題を孕んでいます。
        <br />
        <br />
        また、人材確保並びに人材育成の観点からもノー残業デーは必要です。働き方改革の流れを汲むだけでなく、そもそも既に多くの業種で法律上、時間外労働の上限規制が課せられています。また、時間は有限であることから、より効率的な働き方をしなければ企業の生産性は上がらず、人件費を差し引いた分の企業としての利益を上げることが難しくなります。
      </p>

      <div id="toc2">
        <h1>ノー残業デーのメリット</h1>
      </div>
      <p>
        企業経営的なメリットとして、
        <span>人件費の圧縮が挙げられます</span>
        。当然、制度として特定の曜日に残業がなくなるため、人件費が下がるはずです。しかし、持ち帰り残業等を黙認することは許されませんので、事前に周知期間を設けて制度として適切な運営をしていくことが求められます。
        <br />
        <br />
        他のメリットとして、ノー残業デーを設定することにより
        <span>
          「定時で終わるためにはどのように仕事を進めるべきか」という視点に立ち、逆算した思考となる
        </span>
        ため、ノー残業デーを設けていない日にも波及してよりより働き方が根付くことが考えられます。
      </p>

      <div id="toc3">
        <h1>ノー残業デーのデメリット</h1>
      </div>
      <p>
        他の曜日の業務負荷が上がってしまうことが挙げられます。既に業務量等が一定以上の労働者に起こることですが、
        <span>
          企業が一方的にノー残業デーを設定しても責任の範囲や業務量、業務負荷が何ら変わらない状態ではノー残業デーを設定した曜日のみ時間外労働が少なくなっているように見えるだけ
        </span>
        となります。当然その分のしわ寄せが他の曜日にいってしまい、場合によってはノー残業デーを入れたことで、他の曜日の労働時間が深夜にまで及んでしまい、逆に健康被害が生ずるといったことが考えられます。
        <br />
        <br />
        他のデメリットとして
        <span>労働者の収入減に直結する</span>
        ということです。当然、雇用契約は働いた時間に対する対価を支払うという性質上、労働時間が短くなることで支給額も下がるという構造になります。そうなると、より高収入が期待できる企業へ転職するという発想になることが考えられます。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc4">
        <h1>継続させるためのコツ</h1>
      </div>
      <p>
        ノー残業デーを継続させるには
        <span>
          時間に応じた評価のみではなく、労働者が取得した資格やスキルを評価する制度を導入することが有用
        </span>
        です。当然、ノー残業デーを導入することで残業代が減ることは明白です。その部分にフォーカスされてしまうと特定の労働者の不満に繋がりますので、デメリット部分にあたる
        <span>「残業代が減る」部分に対する緩和策が重要</span>
        となります。そこで、労働者が取得した資格やスキルを評価する制度を導入することで、労働者自身のスキルアップが期待できるため、会社の業績向上にも寄与することが期待できます。
        <br />
        <br />
        また、
        <span>周知徹底も継続させるためのコツ</span>
        です。制度が形骸化してしまう理由の一つとして、導入当初と比較すると段々と労働者の意識が希薄になってしまうことです。これはノー残業デーに限った話ではありませんが、時間の経過とともに制度が廃れてしまうことはよくあることであり、周知徹底をすることで、形骸化していったとしても、再度、制度を軌道に乗せることができます。そのためにも
        <span>
          会社としてだけでなく、中間管理職からも定期的にリマインドを入れる
        </span>
        などの小さな工夫が重要です。
        <br />
        <br />
        また、一度「例外」を認めたとしてもそれを恒常的に認めることも避けるべきです。一例として、
        <span>
          ノー残業デーであるにも関わらず、一度残業を認めたとしましょう。ただし、これは緊急かつ例外的な対応であり、以後はノー残業デーを守ってもらうよう指導、助言をすべきです
        </span>
        。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        ノー残業デーの導入は多くの企業で導入されている「働き方改革」の一形態です。労働者目線でも残業は必要最低限行うものの、可能な限りしたくない（特に「お付き合い残業」）と考える労働者にとっては大いに歓迎される制度ではありますが、多くの場合、一定数の反対層が存在します。そして、単に形式的に導入することは会社に対して逆に不信感を招いてしまうことも考えられます。導入すると決断した場合は、導入後も制度の運営状態を定期的にチェックし、ノー残業デーが形骸化することのないよう継続して運営していくことが重要です。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0087
